import { useMemo } from "react";
import { useServiceContext } from "../../contexts/services/hooks/use-services-context";
import type { ServiceContextValue } from "../../contexts/services/types/services";

export type SdkStatus = Omit<ServiceContextValue, "sdk">;

/** Avancement du démarrage de la session SDK. */
export function useSdkStatus(): SdkStatus {
    const { isInitialized, isConsentManagerReady, startupType } =
        useServiceContext();

    return useMemo(
        () => ({ isInitialized, isConsentManagerReady, startupType }),
        [isInitialized, isConsentManagerReady, startupType],
    );
}
